module.exports = __webpack_public_path__ + "static/media/icon_fukuoka_no_image.d926cd24.png";